import React from 'react';
import { Navbar } from '../../components/Navbar';
import { Footer } from '../../components/Footer';
import { PageHeroBanner } from '../../components/PageHeroBanner';
import { ServiceCTABanner } from '../../components/ServiceCTABanner';
import { CTAButton, CTABar, CTAButtonOnBlue, MidPageCTAStrip } from '../../components/ServiceInlineCTA';
import { CheckCircleIcon, LeafIcon, WrenchIcon, ThumbsUpIcon, ArrowRightIcon, UsersIcon, DollarSignIcon, ShieldCheckIcon, SparklesIcon, HeartIcon, ClockIcon, HomeIcon } from 'lucide-react';
const OTHER_SERVICES = [{
  name: 'Commercial Cleaning',
  slug: 'commercial-cleaning',
  img: 'https://cdn.magicpatterns.com/uploads/wNfvE2GAtkNAfy1MY4Qa6Y/bcpw-service-commercial-cleaning-576x1024.webp'
}, {
  name: 'Driveway Cleaning',
  slug: 'driveway-cleaning',
  img: 'https://cdn.magicpatterns.com/uploads/u5rvnHTQ8C2zZ747ot3d8a/lpw-service-driveway-cleaning-488x650.webp'
}, {
  name: 'Paver Cleaning',
  slug: 'paver-cleaning',
  img: 'https://cdn.magicpatterns.com/uploads/3MyhdEBmvuewzveVgi1yVk/lpw-service-paver-cleaning-488x650.webp'
}, {
  name: 'Solar Panel Cleaning',
  slug: 'solar-panel-cleaning',
  img: 'https://cdn.magicpatterns.com/uploads/7mkWmxZ6rJMX6ZT3SbVLdq/lpw-service-solar-panel-cleaning-577x1024.webp'
}, {
  name: 'Trash Can Cleaning',
  slug: 'trash-can-cleaning',
  img: 'https://cdn.magicpatterns.com/uploads/s8dNva1jhGj3tfrzpuizCn/lpw-service-trash-can-cleaning-488x650.webp'
}, {
  name: 'Window Cleaning',
  slug: 'window-cleaning',
  img: 'https://cdn.magicpatterns.com/uploads/4wiNEq1mR2Agh4kR5DHda3/lpw-service-window-cleaning-600x450.webp'
}];
const headingStyle = {
  color: '#0283C7',
  fontFamily: 'Montserrat, sans-serif',
  fontWeight: 900 as const,
  lineHeight: 1.2
};
const bodyStyle = {
  color: '#025A8A',
  fontFamily: 'Inter, sans-serif',
  fontSize: '16px',
  lineHeight: 1.8
};
const subHeadingStyle = {
  color: '#0283C7',
  fontFamily: 'Montserrat, sans-serif',
  fontWeight: 800 as const,
  lineHeight: 1.3
};
export function BackyardCleaningPage() {
  return <div className="w-full min-h-screen" style={{
    fontFamily: 'Inter, sans-serif'
  }} data-id="element-1023">
      <Navbar data-id="element-1024" />
      <main data-id="element-1025">
        {/* Hero */}
        <PageHeroBanner eyebrow="Service" headline="Backyard Cleaning" subheadline="Our Backyard Cleaning services provide fast, reliable care for your outdoor space, including debris removal, lawn care, and power washing. Enjoy a spotless backyard with affordable, eco-friendly solutions tailored to your needs." ctaPrimary={{
        label: 'Get A Free Quote',
        href: '#quote'
      }} ctaSecondary={{
        label: 'Get Started',
        href: '#contact'
      }} data-id="element-1026" />

        {/* Section — Service Overview (Split Layout) */}
        <section className="w-full py-20 px-4" style={{
        backgroundColor: '#ffffff'
      }} data-id="element-1027">
          <div className="max-w-7xl mx-auto" data-id="element-1028">
            <div className="flex flex-col lg:flex-row items-start gap-12 lg:gap-16" data-id="element-1029">
              <div className="w-full lg:w-1/2" data-id="element-1030">
                <div className="rounded-2xl overflow-hidden" style={{
                boxShadow: '0 20px 60px rgba(2,131,199,0.15)'
              }} data-id="element-1031">
                  <img src="https://cdn.magicpatterns.com/uploads/ahgarkrhWBWZi14WY7Vatg/lpw-service-backyard-cleaning-488x650.webp" alt="Backyard Cleaning Service" className="w-full h-auto object-cover" style={{
                  maxHeight: '500px'
                }} data-id="element-1032" />
                </div>
              </div>
              <div className="w-full lg:w-1/2" data-id="element-1033">
                <h2 className="font-bold mb-6" style={{
                ...headingStyle,
                fontSize: 'clamp(24px, 4vw, 30px)'
              }} data-id="element-1034">
                  Backyard Cleaning
                </h2>
                <p className="mb-4" style={bodyStyle} data-id="element-1035">
                  Our Backyard Cleaning services offer a fast and reliable way
                  to keep your outdoor space spotless year-round. We handle
                  everything from debris removal and lawn care to power washing
                  patios and cleaning outdoor furniture. Whether you need a
                  one-time deep clean or regular upkeep, we provide affordable,
                  eco-friendly solutions tailored to your schedule, so you can
                  enjoy a pristine backyard with minimal effort.
                </p>
                <ul className="mt-6 space-y-3" data-id="element-1036">
                  <li className="flex items-start gap-3" data-id="element-1037">
                    <CheckCircleIcon className="h-5 w-5 flex-shrink-0 mt-0.5" style={{
                    color: '#0283C7'
                  }} data-id="element-1038" />
                    <span style={{
                    ...bodyStyle,
                    fontSize: '15px'
                  }} data-id="element-1039">
                      Debris &amp; leaf removal
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-1040">
                    <CheckCircleIcon className="h-5 w-5 flex-shrink-0 mt-0.5" style={{
                    color: '#0283C7'
                  }} data-id="element-1041" />
                    <span style={{
                    ...bodyStyle,
                    fontSize: '15px'
                  }} data-id="element-1042">
                      Patio &amp; deck power washing
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-1043">
                    <CheckCircleIcon className="h-5 w-5 flex-shrink-0 mt-0.5" style={{
                    color: '#0283C7'
                  }} data-id="element-1044" />
                    <span style={{
                    ...bodyStyle,
                    fontSize: '15px'
                  }} data-id="element-1045">
                      Outdoor furniture cleaning
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-1046">
                    <CheckCircleIcon className="h-5 w-5 flex-shrink-0 mt-0.5" style={{
                    color: '#0283C7'
                  }} data-id="element-1047" />
                    <span style={{
                    ...bodyStyle,
                    fontSize: '15px'
                  }} data-id="element-1048">
                      Mold &amp; mildew treatment
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-1049">
                    <CheckCircleIcon className="h-5 w-5 flex-shrink-0 mt-0.5" style={{
                    color: '#0283C7'
                  }} data-id="element-1050" />
                    <span style={{
                    ...bodyStyle,
                    fontSize: '15px'
                  }} data-id="element-1051">
                      Eco-friendly products
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>

        {/* Inline CTA */}
        <CTAButton data-id="element-1052" />

        {/* Section — Transform Your Outdoor Space */}
        <section className="w-full py-20 px-4" style={{
        backgroundColor: '#E8F4FD'
      }} data-id="element-1053">
          <div className="max-w-4xl mx-auto" data-id="element-1054">
            <h2 className="font-bold text-center mb-8" style={{
            ...headingStyle,
            fontSize: 'clamp(24px, 4vw, 32px)'
          }} data-id="element-1055">
              Backyard Cleaning Services: Transform Your Outdoor Space
            </h2>
            <p className="text-center" style={bodyStyle} data-id="element-1056">
              A well-maintained backyard not only enhances the beauty of your
              home but also provides a relaxing retreat for you and your family.
              Over time, however, backyards can accumulate dirt, debris, mold,
              mildew, and even insect infestations, making them less enjoyable
              to use. Our professional backyard cleaning service is designed to
              restore your outdoor space to its full potential, ensuring it is
              clean, safe, and inviting year-round.
            </p>
          </div>
        </section>

        {/* Inline CTA Bar */}
        <CTABar data-id="element-1057" />

        {/* Section — Comprehensive Solutions */}
        <section className="w-full py-20 px-4" style={{
        backgroundColor: '#ffffff'
      }} data-id="element-1058">
          <div className="max-w-7xl mx-auto" data-id="element-1059">
            <h2 className="font-bold text-center mb-4" style={{
            ...headingStyle,
            fontSize: 'clamp(24px, 4vw, 32px)'
          }} data-id="element-1060">
              Comprehensive Backyard Cleaning Solutions
            </h2>
            <p className="text-center mb-14 max-w-3xl mx-auto" style={bodyStyle} data-id="element-1061">
              Our backyard cleaning service goes beyond just removing leaves or
              mowing the lawn. We offer a thorough cleaning tailored to your
              specific needs, ensuring every corner of your backyard is
              revitalized. Here's what our service includes:
            </p>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-1062">
              {/* 1. Patio and Deck */}
              <div className="p-8 rounded-2xl" style={{
              backgroundColor: '#E8F4FD'
            }} data-id="element-1063">
                <div className="flex items-center gap-4 mb-4" data-id="element-1064">
                  <div className="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0" style={{
                  backgroundColor: '#0283C7'
                }} data-id="element-1065">
                    <span className="text-white font-bold text-sm" style={{
                    fontFamily: 'Montserrat, sans-serif'
                  }} data-id="element-1066">
                      1
                    </span>
                  </div>
                  <h3 className="font-bold" style={{
                  ...subHeadingStyle,
                  fontSize: '18px'
                }} data-id="element-1067">
                    Patio and Deck Cleaning
                  </h3>
                </div>
                <p style={{
                ...bodyStyle,
                fontSize: '15px'
              }} data-id="element-1068">
                  Patios and decks are often the centerpieces of a backyard, but
                  they can become stained by weather exposure, spilled food, or
                  mold growth. We provide pressure washing and gentle cleaning
                  techniques to remove stains, grime, and mildew from wood,
                  concrete, brick, or stone surfaces, leaving your outdoor
                  entertaining area looking fresh and new.
                </p>
              </div>

              {/* 2. Fence Cleaning */}
              <div className="p-8 rounded-2xl" style={{
              backgroundColor: '#E8F4FD'
            }} data-id="element-1069">
                <div className="flex items-center gap-4 mb-4" data-id="element-1070">
                  <div className="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0" style={{
                  backgroundColor: '#0283C7'
                }} data-id="element-1071">
                    <span className="text-white font-bold text-sm" style={{
                    fontFamily: 'Montserrat, sans-serif'
                  }} data-id="element-1072">
                      2
                    </span>
                  </div>
                  <h3 className="font-bold" style={{
                  ...subHeadingStyle,
                  fontSize: '18px'
                }} data-id="element-1073">
                    Fence Cleaning
                  </h3>
                </div>
                <p style={{
                ...bodyStyle,
                fontSize: '15px'
              }} data-id="element-1074">
                  Fences often collect dirt, algae, and grime over time,
                  detracting from the overall look of your backyard. Whether
                  your fence is wood, vinyl, or metal, our team will clean and
                  restore its original appearance using appropriate methods to
                  avoid damage while achieving maximum cleanliness.
                </p>
              </div>

              {/* 3. Outdoor Furniture */}
              <div className="p-8 rounded-2xl" style={{
              backgroundColor: '#E8F4FD'
            }} data-id="element-1075">
                <div className="flex items-center gap-4 mb-4" data-id="element-1076">
                  <div className="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0" style={{
                  backgroundColor: '#0283C7'
                }} data-id="element-1077">
                    <span className="text-white font-bold text-sm" style={{
                    fontFamily: 'Montserrat, sans-serif'
                  }} data-id="element-1078">
                      3
                    </span>
                  </div>
                  <h3 className="font-bold" style={{
                  ...subHeadingStyle,
                  fontSize: '18px'
                }} data-id="element-1079">
                    Outdoor Furniture Cleaning
                  </h3>
                </div>
                <p style={{
                ...bodyStyle,
                fontSize: '15px'
              }} data-id="element-1080">
                  Outdoor furniture is exposed to the elements and can gather
                  dust, pollen, and other debris that make it look worn out. We
                  clean and sanitize outdoor tables, chairs, and lounges,
                  ensuring they are free of dirt and allergens, so they are
                  ready for you to relax or entertain guests.
                </p>
              </div>

              {/* 4. Grill and Outdoor Kitchen */}
              <div className="p-8 rounded-2xl" style={{
              backgroundColor: '#E8F4FD'
            }} data-id="element-1081">
                <div className="flex items-center gap-4 mb-4" data-id="element-1082">
                  <div className="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0" style={{
                  backgroundColor: '#0283C7'
                }} data-id="element-1083">
                    <span className="text-white font-bold text-sm" style={{
                    fontFamily: 'Montserrat, sans-serif'
                  }} data-id="element-1084">
                      4
                    </span>
                  </div>
                  <h3 className="font-bold" style={{
                  ...subHeadingStyle,
                  fontSize: '18px'
                }} data-id="element-1085">
                    Grill and Outdoor Kitchen Cleaning
                  </h3>
                </div>
                <p style={{
                ...bodyStyle,
                fontSize: '15px'
              }} data-id="element-1086">
                  If you have an outdoor kitchen or grilling area, our team will
                  deep clean your grill and cooking surfaces. We ensure that any
                  built-up grease or food residue is removed, allowing you to
                  cook safely and enjoy your outdoor dining space without
                  worrying about hygiene.
                </p>
              </div>

              {/* 5. Gutter and Downspout */}
              <div className="p-8 rounded-2xl" style={{
              backgroundColor: '#E8F4FD'
            }} data-id="element-1087">
                <div className="flex items-center gap-4 mb-4" data-id="element-1088">
                  <div className="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0" style={{
                  backgroundColor: '#0283C7'
                }} data-id="element-1089">
                    <span className="text-white font-bold text-sm" style={{
                    fontFamily: 'Montserrat, sans-serif'
                  }} data-id="element-1090">
                      5
                    </span>
                  </div>
                  <h3 className="font-bold" style={{
                  ...subHeadingStyle,
                  fontSize: '18px'
                }} data-id="element-1091">
                    Gutter and Downspout Cleaning
                  </h3>
                </div>
                <p style={{
                ...bodyStyle,
                fontSize: '15px'
              }} data-id="element-1092">
                  Clean gutters and downspouts are essential for proper drainage
                  in your backyard. Our team will remove leaves, dirt, and other
                  debris from your gutter system, ensuring water flows properly
                  and doesn't pool in your yard, which can lead to erosion or
                  mold growth around the house.
                </p>
              </div>

              {/* 6. Garden Bed */}
              <div className="p-8 rounded-2xl" style={{
              backgroundColor: '#E8F4FD'
            }} data-id="element-1093">
                <div className="flex items-center gap-4 mb-4" data-id="element-1094">
                  <div className="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0" style={{
                  backgroundColor: '#0283C7'
                }} data-id="element-1095">
                    <span className="text-white font-bold text-sm" style={{
                    fontFamily: 'Montserrat, sans-serif'
                  }} data-id="element-1096">
                      6
                    </span>
                  </div>
                  <h3 className="font-bold" style={{
                  ...subHeadingStyle,
                  fontSize: '18px'
                }} data-id="element-1097">
                    Garden Bed and Landscaping Clean-Up
                  </h3>
                </div>
                <p style={{
                ...bodyStyle,
                fontSize: '15px'
              }} data-id="element-1098">
                  Overgrown plants, fallen leaves, and weeds can quickly make a
                  backyard feel unkempt. We offer garden bed cleanup services to
                  remove debris, trim hedges, and weed overgrown areas, ensuring
                  your plants and flowers thrive and look beautiful.
                </p>
              </div>

              {/* 7. Pool Deck */}
              <div className="p-8 rounded-2xl" style={{
              backgroundColor: '#E8F4FD'
            }} data-id="element-1099">
                <div className="flex items-center gap-4 mb-4" data-id="element-1100">
                  <div className="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0" style={{
                  backgroundColor: '#0283C7'
                }} data-id="element-1101">
                    <span className="text-white font-bold text-sm" style={{
                    fontFamily: 'Montserrat, sans-serif'
                  }} data-id="element-1102">
                      7
                    </span>
                  </div>
                  <h3 className="font-bold" style={{
                  ...subHeadingStyle,
                  fontSize: '18px'
                }} data-id="element-1103">
                    Pool Deck and Poolside Cleaning
                  </h3>
                </div>
                <p style={{
                ...bodyStyle,
                fontSize: '15px'
              }} data-id="element-1104">
                  If you have a pool, keeping the area around it clean is vital
                  for safety and aesthetics. We pressure wash pool decks and
                  poolside furniture to remove slippery algae, mold, and grime,
                  ensuring that your pool area is safe for family and guests to
                  enjoy.
                </p>
              </div>

              {/* 8. Pathway */}
              <div className="p-8 rounded-2xl" style={{
              backgroundColor: '#E8F4FD'
            }} data-id="element-1105">
                <div className="flex items-center gap-4 mb-4" data-id="element-1106">
                  <div className="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0" style={{
                  backgroundColor: '#0283C7'
                }} data-id="element-1107">
                    <span className="text-white font-bold text-sm" style={{
                    fontFamily: 'Montserrat, sans-serif'
                  }} data-id="element-1108">
                      8
                    </span>
                  </div>
                  <h3 className="font-bold" style={{
                  ...subHeadingStyle,
                  fontSize: '18px'
                }} data-id="element-1109">
                    Pathway and Walkway Pressure Washing
                  </h3>
                </div>
                <p style={{
                ...bodyStyle,
                fontSize: '15px'
              }} data-id="element-1110">
                  Concrete, stone, or brick pathways can become dirty and grimy
                  due to foot traffic and weather conditions. Our pressure
                  washing service restores the appearance of your walkways,
                  making them cleaner and safer to walk on by removing dirt,
                  moss, and other buildup.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Section — Why Choose Us */}
        <section className="w-full py-20 px-4" style={{
        backgroundColor: '#E8F4FD'
      }} data-id="element-1111">
          <div className="max-w-7xl mx-auto" data-id="element-1112">
            <h2 className="font-bold text-center mb-14" style={{
            ...headingStyle,
            fontSize: 'clamp(24px, 4vw, 32px)'
          }} data-id="element-1113">
              Why Choose Our Backyard Cleaning Service?
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-1114">
              <div className="bg-white text-center p-8 rounded-2xl" style={{
              boxShadow: '0 4px 20px rgba(2,131,199,0.08)'
            }} data-id="element-1115">
                <div className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-6" style={{
                backgroundColor: '#0283C7'
              }} data-id="element-1116">
                  <UsersIcon className="h-7 w-7 text-white" data-id="element-1117" />
                </div>
                <h3 className="font-bold mb-3" style={{
                ...subHeadingStyle,
                fontSize: '18px'
              }} data-id="element-1118">
                  Expert Team
                </h3>
                <p style={{
                ...bodyStyle,
                fontSize: '14px'
              }} data-id="element-1119">
                  Our trained professionals use industry-leading techniques and
                  eco-friendly products to clean your backyard without damaging
                  plants, furniture, or structures.
                </p>
              </div>

              <div className="bg-white text-center p-8 rounded-2xl" style={{
              boxShadow: '0 4px 20px rgba(2,131,199,0.08)'
            }} data-id="element-1120">
                <div className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-6" style={{
                backgroundColor: '#0283C7'
              }} data-id="element-1121">
                  <WrenchIcon className="h-7 w-7 text-white" data-id="element-1122" />
                </div>
                <h3 className="font-bold mb-3" style={{
                ...subHeadingStyle,
                fontSize: '18px'
              }} data-id="element-1123">
                  Customized Service
                </h3>
                <p style={{
                ...bodyStyle,
                fontSize: '14px'
              }} data-id="element-1124">
                  We understand that every backyard is unique, so we tailor our
                  services to your specific needs, focusing on the areas that
                  matter most to you.
                </p>
              </div>

              <div className="bg-white text-center p-8 rounded-2xl" style={{
              boxShadow: '0 4px 20px rgba(2,131,199,0.08)'
            }} data-id="element-1125">
                <div className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-6" style={{
                backgroundColor: '#0283C7'
              }} data-id="element-1126">
                  <DollarSignIcon className="h-7 w-7 text-white" data-id="element-1127" />
                </div>
                <h3 className="font-bold mb-3" style={{
                ...subHeadingStyle,
                fontSize: '18px'
              }} data-id="element-1128">
                  Affordable Pricing
                </h3>
                <p style={{
                ...bodyStyle,
                fontSize: '14px'
              }} data-id="element-1129">
                  We offer competitive pricing for our backyard cleaning
                  services, ensuring you get excellent value for money.
                </p>
              </div>

              <div className="bg-white text-center p-8 rounded-2xl" style={{
              boxShadow: '0 4px 20px rgba(2,131,199,0.08)'
            }} data-id="element-1130">
                <div className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-6" style={{
                backgroundColor: '#0283C7'
              }} data-id="element-1131">
                  <ThumbsUpIcon className="h-7 w-7 text-white" data-id="element-1132" />
                </div>
                <h3 className="font-bold mb-3" style={{
                ...subHeadingStyle,
                fontSize: '18px'
              }} data-id="element-1133">
                  Satisfaction Guaranteed
                </h3>
                <p style={{
                ...bodyStyle,
                fontSize: '14px'
              }} data-id="element-1134">
                  Our goal is to leave you 100% satisfied with the results. We
                  work diligently to ensure your backyard is transformed into a
                  clean and inviting space that you'll love to spend time in.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Inline CTA */}
        <CTAButtonOnBlue data-id="element-1135" />

        {/* Section — Benefits */}
        <section className="w-full py-20 px-4" style={{
        backgroundColor: '#ffffff'
      }} data-id="element-1136">
          <div className="max-w-7xl mx-auto" data-id="element-1137">
            <h2 className="font-bold text-center mb-14" style={{
            ...headingStyle,
            fontSize: 'clamp(24px, 4vw, 32px)'
          }} data-id="element-1138">
              Benefits of Professional Backyard Cleaning
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-1139">
              <div className="flex gap-5" data-id="element-1140">
                <div className="w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0" style={{
                backgroundColor: '#E8F4FD'
              }} data-id="element-1141">
                  <HomeIcon className="h-6 w-6" style={{
                  color: '#0283C7'
                }} data-id="element-1142" />
                </div>
                <div data-id="element-1143">
                  <h3 className="font-bold mb-2" style={{
                  ...subHeadingStyle,
                  fontSize: '18px'
                }} data-id="element-1144">
                    Enhance Property Value
                  </h3>
                  <p style={{
                  ...bodyStyle,
                  fontSize: '15px'
                }} data-id="element-1145">
                    A well-maintained backyard improves the overall appearance
                    of your home and can boost its market value.
                  </p>
                </div>
              </div>

              <div className="flex gap-5" data-id="element-1146">
                <div className="w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0" style={{
                backgroundColor: '#E8F4FD'
              }} data-id="element-1147">
                  <HeartIcon className="h-6 w-6" style={{
                  color: '#0283C7'
                }} data-id="element-1148" />
                </div>
                <div data-id="element-1149">
                  <h3 className="font-bold mb-2" style={{
                  ...subHeadingStyle,
                  fontSize: '18px'
                }} data-id="element-1150">
                    Promote a Healthy Environment
                  </h3>
                  <p style={{
                  ...bodyStyle,
                  fontSize: '15px'
                }} data-id="element-1151">
                    Regular cleaning prevents the growth of mold, mildew, and
                    algae, reducing allergens and creating a healthier outdoor
                    space for you and your family.
                  </p>
                </div>
              </div>

              <div className="flex gap-5" data-id="element-1152">
                <div className="w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0" style={{
                backgroundColor: '#E8F4FD'
              }} data-id="element-1153">
                  <ShieldCheckIcon className="h-6 w-6" style={{
                  color: '#0283C7'
                }} data-id="element-1154" />
                </div>
                <div data-id="element-1155">
                  <h3 className="font-bold mb-2" style={{
                  ...subHeadingStyle,
                  fontSize: '18px'
                }} data-id="element-1156">
                    Prevent Damage
                  </h3>
                  <p style={{
                  ...bodyStyle,
                  fontSize: '15px'
                }} data-id="element-1157">
                    Dirt, mold, and grime can degrade your outdoor structures
                    over time. Professional cleaning helps protect your deck,
                    patio, fences, and furniture from long-term damage.
                  </p>
                </div>
              </div>

              <div className="flex gap-5" data-id="element-1158">
                <div className="w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0" style={{
                backgroundColor: '#E8F4FD'
              }} data-id="element-1159">
                  <ClockIcon className="h-6 w-6" style={{
                  color: '#0283C7'
                }} data-id="element-1160" />
                </div>
                <div data-id="element-1161">
                  <h3 className="font-bold mb-2" style={{
                  ...subHeadingStyle,
                  fontSize: '18px'
                }} data-id="element-1162">
                    Save Time and Effort
                  </h3>
                  <p style={{
                  ...bodyStyle,
                  fontSize: '15px'
                }} data-id="element-1163">
                    Cleaning a backyard can be a time-consuming and physically
                    demanding task. By hiring professionals, you can relax while
                    we take care of everything.
                  </p>
                </div>
              </div>
            </div>

            <p className="text-center mt-12 max-w-3xl mx-auto" style={bodyStyle} data-id="element-1164">
              Whether you want to get your backyard ready for a summer BBQ,
              prepare for winter, or simply maintain its appearance throughout
              the year, our exterior backyard cleaning service is the perfect
              solution. Let us help you create an outdoor space that you'll be
              proud to enjoy and show off to guests.
            </p>
          </div>
        </section>

        {/* Mid-Page CTA Strip */}
        <MidPageCTAStrip data-id="element-1165" />

        {/* Section — Other Services */}
        <section className="w-full py-20 px-4" style={{
        backgroundColor: '#E8F4FD'
      }} data-id="element-1166">
          <div className="max-w-7xl mx-auto" data-id="element-1167">
            <h2 className="font-bold text-center mb-12" style={{
            ...headingStyle,
            fontSize: 'clamp(24px, 4vw, 30px)'
          }} data-id="element-1168">
              Explore Our Other Services
            </h2>
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4" data-id="element-1169">
              {OTHER_SERVICES.map(service => <a key={service.slug} href={`/services/${service.slug}`} className="bg-white rounded-xl p-5 text-center transition-all hover:shadow-lg hover:scale-[1.02] flex flex-col items-center gap-3" style={{
              boxShadow: '0 2px 12px rgba(2,131,199,0.08)'
            }} data-id="element-1170">
                  <div className="w-14 h-14 rounded-full overflow-hidden flex-shrink-0" style={{
                backgroundColor: '#E8F4FD'
              }} data-id="element-1171">
                    <img src={service.img} alt={service.name} className="w-full h-full object-cover" data-id="element-1172" />
                  </div>
                  <p className="font-bold text-sm" style={{
                color: '#0283C7',
                fontFamily: 'Montserrat, sans-serif',
                fontSize: '13px'
              }} data-id="element-1173">
                    {service.name}
                  </p>
                  <span className="flex items-center gap-1 text-xs font-semibold" style={{
                color: '#0283C7',
                fontFamily: 'Inter, sans-serif'
              }} data-id="element-1174">
                    Learn More <ArrowRightIcon className="h-3 w-3" data-id="element-1175" />
                  </span>
                </a>)}
            </div>
          </div>
        </section>

        {/* CTA Banner */}
        <ServiceCTABanner headline="Ready for a Cleaner Backyard?" data-id="element-1176" />
      </main>
      <Footer data-id="element-1177" />
    </div>;
}